import React, { Fragment } from "react";

import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MenuIcon from "@material-ui/icons/Menu";
import SearchBar from "material-ui-search-bar";
import Grid from "@material-ui/core/Grid";
import FilterListIcon from '@material-ui/icons/FilterList';
import Icon from '@material-ui/core/Icon';
import DialogBox from './DialogBox';
import { makeStyles } from "@material-ui/core/styles";
import { devicesActions, mapStateTypesActions } from "./store";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  menuItemCss: {
    // background:'red',
    '&:hover': {
      background: "#b3aeae",
   },
  }
}));

let timeout = null;
const FilterView = (props) => {
    const { updateFilter } = props;
    const [search, setSearch] = React.useState('');
    const [filter, setFilter] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isOpenDialog, setIsOpenDialog] = React.useState(false);
    const classes = useStyles();
    const dispatch = useDispatch();


    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const searchChange = (val) => {
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        setSearch(val);
        updateFilter({ search: val, filter });
      }, 1000);
    };

    const handleMenuClick = (val) => {
      setFilter(val);
      updateFilter({ search, filter: val });
      setAnchorEl(null);
      resetToHome();
    };

    const handleClose = (val) => {
      setAnchorEl(null);
    };

    const reset = () => {
      setFilter("");
      setSearch("");
      updateFilter({ search: "", filter: "" });
      resetToHome();
    };

    const resetToHome = () => {
      props.reSetMap();
      // dispatch(devicesActions.select(null));
      // dispatch(mapStateTypesActions.addState("HOME"));
    };

    const onConfirm = () => {
      setIsOpenDialog(false);
    };

    const onCancel = () => {
      setIsOpenDialog(false);
    };
    // const doSomethingWith = (value) => {};
    return (
      <div style={{ marginTop: "10px" }}>
        <DialogBox
          sweetAlertProps={{
            title: "Do you like thumbs?",
            show: isOpenDialog, // must have prop
            onConfirm: onConfirm,
            onCancel: onCancel, // must have prop
            // custom:true,
            showCancel: true,
            showCloseButton: true,
            confirmBtnText: "Yes",
            cancelBtnText: "No",
            confirmBtnBsStyle: "primary",
            cancelBtnBsStyle: "light",
          }}
        >
          You will find they are up!
          {/* Children custom html here */}
        </DialogBox>
        <Grid container spacing={1}>
          <Grid item xs={11} sm={7}>
            <SearchBar
              value={search}
              onChange={searchChange}
              onCancelSearch={reset}
              placeholder="Search here..."
              className="searchBarInput"
              style={{
                borderRadius: 15,
                marginLeft: "20px",
                height: 35,
                boxShadow: "2px 2px 2px 2px #dbddef",
                fontSize: 12,
              }}
              // onRequestSearch={() => doSomethingWith()}
            />
          </Grid>
          <Grid item xs={5} sm={5}>
            <Grid container spacing={1}>
              <Grid item xs={7} sm={7}>
                <Button
                  variant="contained"
                  color="primary"
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                  style={{
                    borderRadius: 15,
                    color: "#fff",
                    marginLeft: "20px",
                    fontSize: 12,
                    boxShadow: "2px 2px 2px 2px #dbddef",
                  }}
                >
                  {filter || "Filter"}
                </Button>
              </Grid>
              <Grid item xs={4} sm={4}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={reset}
                  style={{
                    borderRadius: 15,
                    color: "#fff",
                    marginLeft: "10px",
                    fontSize: 12,
                    boxShadow: "2px 2px 2px 2px #dbddef",
                  }}
                >
                  All
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          icon={<FilterListIcon />}
        >
          {/* <MenuItem className = {classes.menuItemCss} onClick={reset}>All</MenuItem> */}
          <MenuItem
            className={classes.menuItemCss}
            onClick={() => handleMenuClick("running")}
          >
            Running
          </MenuItem>
          <MenuItem
            className={classes.menuItemCss}
            onClick={() => handleMenuClick("stopped")}
          >
            Stopped
          </MenuItem>
          <MenuItem
            className={classes.menuItemCss}
            onClick={() => handleMenuClick("idle")}
          >
            Idle
          </MenuItem>
          <MenuItem
            className={classes.menuItemCss}
            onClick={() => handleMenuClick("inactive")}
          >
            Inactive
          </MenuItem>
          <MenuItem
            className={classes.menuItemCss}
            onClick={() => handleMenuClick("expired")}
          >
            Expired
          </MenuItem>
          <MenuItem
            className={classes.menuItemCss}
            onClick={() => handleMenuClick("noData")}
          >
            No Data
          </MenuItem>
          <MenuItem
            className={classes.menuItemCss}
            onClick={() => handleMenuClick("expiringSoon")}
          >
            Exp. Soon
          </MenuItem>
        </Menu>
      </div>
    );
  };
  
  export default FilterView;